// extracted by mini-css-extract-plugin
export var clickThrough = "_z2-2";
export var fallback = "_z2-5";
export var frame = "_z2-3";
export var frameCell = "_z2-1";
export var overlay = "_z2-4";
export var wrapper = "_z2-0";